











import { Component, Vue } from 'vue-property-decorator';

/**
 * Page de confirmation de paiement.
 */
@Component
export default class PaymentConfirmPage extends Vue {
}
